(ns renolit-roofing-service.layout.grid-table.cell
  (:require
   [re-frame.core :as rf]
   [renolit-roofing-service.layout.icon :as layout.icon]
   [renolit-roofing-service.localization :refer [t]]
   [renolit-roofing-service.shared.util.time :as util.time]))

(defmulti grid-table-cell
  (fn [_ {:keys [type]}]
    type)
  :default :text)

(defmethod grid-table-cell :text
  [content {:keys [ellipsis format-content-fn]}]
  [:div.grid-table__cell
   {:class (when ellipsis
             "grid-table__cell--ellipsis")
    :title (when ellipsis content)}
   (if (and format-content-fn
            (fn? format-content-fn))
     (format-content-fn content)
     (str content))])

(defmethod grid-table-cell :enum
  [content {:keys [transl-kw-prefix]}]
  [:div.grid-table__cell
   (if transl-kw-prefix
     (t [(keyword (name transl-kw-prefix) (name content))])
     (name content))])

(defmethod grid-table-cell :date
  [content {:keys [format-pattern]
            :or {format-pattern "dd/MM/yyyy"}}]
  [:div.grid-table__cell
   (when content
     (util.time/instant->zoned-date-time-string
      content
      {:format-pattern format-pattern}))])

(defmethod grid-table-cell :local-date
  [content {:keys [format-pattern]
            :or {format-pattern "dd/MM/yyyy"}}]
  [:div.grid-table__cell
   (when content
     (util.time/format-local-date
      content
      {:format-pattern format-pattern}))])

(defmethod grid-table-cell :email
  [content _opts]
  [:div.grid-table__cell
   [:span.nowrap (str content)]])

(defmethod grid-table-cell :icon
  [_content {:keys [icon-name]}]
  [:div.grid-table__cell.grid-table__cell--click-indicator
   [:span
    [layout.icon/icon {:key icon-name}]]])

(defmethod grid-table-cell :custom
  [content {:keys [component] :as opts} row-data]
  [component content opts row-data])

(defmethod grid-table-cell :button
  [_content {:keys [dispatch only-icon? class] :as _opts} & [row-data]]
  [:div.grid-table__cell.no-navigate
   {:on-click (fn [event]
                (when (= "grid-table__cell no-navigate" (.-className (.-target event)))
                  (.preventDefault event)
                  (.stopPropagation event)))}
   [:button.btn
    {:class (cond-> []
              only-icon?
              (conj "btn-only-icon")
              class
              (conj class))
     :on-click (fn [event]
                 (.preventDefault event)
                 (.stopPropagation event)
                 (rf/dispatch [dispatch row-data]))}]])
